import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';


export default function useGetBillingCodes() {

    const { data, error, mutate, isLoading } = useSWR(`${apiBaseURL}/api/Project/BillingCodes`, {
        //onSuccess: (data) => console.log('Billing codes fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });
    
    const billingCodes = data?.data;

    return {
        billingCodes,
        error,
        mutate,
        isLoading,
    }
}